import React, { memo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import URLSearchParams from 'url-search-params'
import { Redirect, Route, Switch, useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { ConfigProvider } from "antd";
import { IntlProvider } from "react-intl";

import AppLocale from "lngProvider";
import MainApp from "./MainApp";
import SignIn from "../SignIn";
import SignUp from "../SignUp";
import ClientSignIn from "../ClientSignIn";
import ClientSignUp from "../ClientSignUp";
import Interstitial from '../Interstitial'
import ForgotPassword from '../forgotPassword'
import ResetPassword from '../resetPassword'
import CSOForm from "../../routes/ProjectManagementTool/CustomerFile/CSOForm";
import ZohoForm from "../../routes/ProjectManagementTool/CustomerFile/ZohoForm";
import SuccessPage from "../../routes/ProjectManagementTool/CustomerFile/SuccessPage";
import { setInitUrl } from "appRedux/actions/Auth";
import { onLayoutTypeChange, onNavStyleChange, setThemeType } from "appRedux/actions/Setting";
import PrivacyPolicy from "../../routes/About/PrivacyPolicy";
import TermsandConditions from "../../routes/About/TermsandConditions";
import USDForm from "../../routes/ProjectManagementTool/Project/USDForm";
import Portal from "../../routes/LandingPage/Portal";
import PartnerRegistration from "../../routes/Registration/PartnerRegistration";
import UserProfiling from "../../routes/AdditionalProfiling/UserProfiling";
import ConversationalProfiling from "../../routes/AdditionalProfiling/ConversationalProfiling";
import ThankYouPage from "../../routes/Registration/ThankYouPage";
import CSATSurvey from "../../routes/Surveys/CSATSurvey";
import DistrictMap from "../../routes/Maps/DistrictMap";
import { isTokenExpired } from "../../util/JWTDecode";
import {
  LAYOUT_TYPE_BOXED,
  LAYOUT_TYPE_FRAMED,
  LAYOUT_TYPE_FULL,
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL
} from "../../constants/ThemeSetting";
// import forgotPassword from "../forgotPassword";
import { Modal } from 'antd';
import CacheBuster from "../../CacheBuster";
import PartnerLoginPage from "../../routes/PartnerLogin/PartnerLoginPage";
import AccountDeletion from "../AccountDeletion";


const RestrictedRoute = ({ component: Component, location, authUser, ...rest }) =>
  // console.log('restr',location, authUser)
  <Route
    {...rest}
    render={props =>
      // authUser
      //   ? <Component {...props} />
      // : <Redirect
      //   to={{
      //     pathname: '/signin',
      //     state: {from: location}
      //   }}
      // : 
      <Component {...props}
      />}
  />;


const App = (props) => {

  const dispatch = useDispatch();
  const { locale, navStyle, layoutType } = useSelector(({ settings }) => settings);
  const { authUser, initURL } = useSelector(({ auth }) => auth);
  const [location, setLocation] = useState(useLocation());
  const [history, setHistory] = useState(useHistory());
  const [match, setMatch] = useState(useRouteMatch());
  // console.log(props,'app props!')


  useEffect(() => {
    // let link = document.createElement('link');
    // link.type = 'text/css';
    // link.rel = 'stylesheet';
    // link.href = "/css/style.css";
    // link.className = 'gx-style';
    // document.body.appendChild(link); 
    setLocation(props.location);
    setHistory(props.history);
    setMatch(props.match)

  }, [props.location, props.match, props.history]);

  useEffect(() => {
    if (initURL === '') {
      dispatch(setInitUrl(location.pathname));
    }
    const params = new URLSearchParams(location.search);

    if (params.has("theme")) {
      dispatch(setThemeType(params.get('theme')));
    }
    if (params.has("nav-style")) {
      dispatch(onNavStyleChange(params.get('nav-style')));
    }
    if (params.has("layout-type")) {
      dispatch(onLayoutTypeChange(params.get('layout-type')));
    }
    setLayoutType(layoutType);
    setNavStyle(navStyle);
  }, [location]);

  const setLayoutType = (layoutType) => {
    if (layoutType === LAYOUT_TYPE_FULL) {
      document.body.classList.remove('boxed-layout');
      document.body.classList.remove('framed-layout');
      document.body.classList.add('full-layout');
    } else if (layoutType === LAYOUT_TYPE_BOXED) {
      document.body.classList.remove('full-layout');
      document.body.classList.remove('framed-layout');
      document.body.classList.add('boxed-layout');
    } else if (layoutType === LAYOUT_TYPE_FRAMED) {
      document.body.classList.remove('boxed-layout');
      document.body.classList.remove('full-layout');
      document.body.classList.add('framed-layout');
    }
  };

  const setNavStyle = (navStyle) => {
    if (navStyle === NAV_STYLE_DEFAULT_HORIZONTAL ||
      navStyle === NAV_STYLE_DARK_HORIZONTAL ||
      navStyle === NAV_STYLE_INSIDE_HEADER_HORIZONTAL ||
      navStyle === NAV_STYLE_ABOVE_HEADER ||
      navStyle === NAV_STYLE_BELOW_HEADER) {
      document.body.classList.add('full-scroll');
      document.body.classList.add('horizontal-layout');
    } else {
      document.body.classList.remove('full-scroll');
      document.body.classList.remove('horizontal-layout');
    }
  };



  function warning() {
    Modal.warning({
      title: 'Token Expired!',
      content: 'Please Login Again!',
      onOk() {
        localStorage.removeItem('token');
        history.push('/portals');
      },
      okText: "Sign In"
    });
  }

  useEffect(() => {
    // if (localStorage.getItem('token') !== null) {
    //   const token = localStorage.getItem('token');
    // if (isTokenExpired(token)) {
    //   warning()
    // }
    // }
    if (location.pathname === '/') {
      if (localStorage.getItem('token') === null) {
        history.push('/portals');
      } else {
        history.push('/signin');
      }
      // else if (initURL === '' || initURL === '/' || initURL === '/signin') {
      //   history.push('/signin');
      // }
    }
  }, [authUser, location, history]);

  const currentAppLocale = AppLocale[locale.locale];
  return (
    <CacheBuster>
      {({ loading }) => {
        if (loading) return null;
        return (
          <ConfigProvider locale={currentAppLocale.antd}>
            <IntlProvider
              locale={currentAppLocale.locale}
              messages={currentAppLocale.messages}>

              <Switch>
                <Route exact path='/signin' component={SignIn} />
                <Route exact path='/signup' component={SignUp} />
                <Route exact path='/client' component={ClientSignIn} />
                <Route exact path='/client-signup' component={ClientSignUp} />
                <Route exact path='/interstitial' component={Interstitial} />
                <Route exact path='/forgot-password' component={ForgotPassword} />
                <Route exact path='/reset-password' component={ResetPassword} />
                <Route exact path='/usd_form/:ticket_id/:project_id' component={USDForm} />
                <Route exact path='/cso_form/:ticket_id/:url_id' component={CSOForm} />
                <Route exact path='/success' component={SuccessPage} />
                <Route exact path='/privacy-policy' component={PrivacyPolicy} />
                <Route exact path='/terms-and-conditions' component={TermsandConditions} />
                <Route exact path='/portals' component={Portal} />
                <Route exact path='/partner-login' component={PartnerLoginPage} />
                <Route exact path='/csat-survey/:ticketId' component={CSATSurvey} />
                <Route exact path='/district-maps' component={DistrictMap} />
                <Route exact path='/account-deletion' component={AccountDeletion} />
                <Route exact path='/partner-registration' component={PartnerRegistration} />
                <Route exact path='/profiling-questionnaire' component={UserProfiling} />
                <Route exact path='/questionnaires' component={ConversationalProfiling} />
                <Route exact path='/thank-you' component={ThankYouPage} />
                <RestrictedRoute path={`${match.url}`} location={location}
                  component={MainApp} />
              </Switch>
            </IntlProvider>
          </ConfigProvider>
        )
      }}
    </CacheBuster>
  );
};

export default memo(App);
